/**
 * Bug hunt store - the in-app audit reporter (FEAT-008).
 *
 * `enabled` (the only persisted field) shows the floating bug button on every
 * screen so Nation can file reports mid-walkthrough. The sheet itself works
 * for everyone regardless of the toggle (Settings opens it directly).
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BugHuntState {
  enabled: boolean;
  sheetOpen: boolean;
  sentCount: number; // session-only badge on the floating button
  setEnabled: (enabled: boolean) => void;
  openSheet: () => void;
  closeSheet: () => void;
  reportSent: () => void;
}

export const useBugHuntStore = create<BugHuntState>()(
  persist(
    (set) => ({
      enabled: false,
      sheetOpen: false,
      sentCount: 0,
      setEnabled: (enabled) => set({ enabled }),
      openSheet: () => set({ sheetOpen: true }),
      closeSheet: () => set({ sheetOpen: false }),
      reportSent: () => set((s) => ({ sentCount: s.sentCount + 1, sheetOpen: false })),
    }),
    {
      name: 'momento-bug-hunt',
      partialize: (state) => ({ enabled: state.enabled }),
    }
  )
);
